import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import { useEffect, useRef, useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';

const PeaceOfMind: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('PeaceOfMind');

    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751250629757/1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1751250630356/1-h5.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751250631208/2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1751250630169/2-h5.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751250630805/3-h5.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1751250630805/3-h5.jpg',
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751250630596/4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1751250631015/4-h5.jpg',
            title: t('item4_title'),
            desc: t('item4_desc'),
        },
    ];

    const [slidesPerView, setSlidesPerView] = useState<'auto' | number>('auto');
    const [spaceBetween, setSpaceBetween] = useState(24);
    const getSlidesPerView = () => {
        if (window.innerWidth > 1024) {
            return 3;
        }
        return 'auto';
    };
    const getSpaceBetween = () => {
        if (window.innerWidth > 1024) {
            return 24;
        }
        return 16;
    };

    // 监听屏幕宽度变化 改变slierPerView
    useEffect(() => {
        const handleResize = () => {
            setSlidesPerView(getSlidesPerView());
            setSpaceBetween(getSpaceBetween());
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className={styles.PeaceOfMind}>
            <EcoSectionCommon title="Plug & Play⁶ and Save With Peace of Mind" />
            <div className="peace-of-mind-box">
                <Swiper
                    slidesPerView={slidesPerView}
                    spaceBetween={spaceBetween}
                    modules={[Navigation]}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    initialSlide={0}
                >
                    {list.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="peace-of-mind-item">
                                <div className="peace-of-mind-item-img">
                                    <EcoImg pc={item.pc} alt={item.title} pad={item.pad} />
                                </div>
                                <div className="peace-of-mind-item-content">
                                    <p className="peace-of-mind-item-title">{item.title}</p>
                                    <p className="peace-of-mind-item-desc">{item.desc}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}

                    <div className="swiper-button-prev" />
                    <div className="swiper-button-next" />
                </Swiper>
            </div>
        </div>
    );
};

export default PeaceOfMind;
